import { useState } from "react";
import { Modal, Button, Card, Row, Col } from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import {images} from "../../constants"

const PeopleRatingsModal = ({show,handleClosepeople}) => {


  // Dummy data (50 sample users)
  const ratingsData = Array.from({ length: 50 }, (_, i) => ({
    id: i + 1,
    username: `User ${i + 1}`,
    rating: Math.floor(Math.random() * 5) + 1,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer vel augue nec libero aliquam elementum.",
  }));

  return (
    <>
 
      {/* Modal */}
      <Modal
        show={show}
        onHide={handleClosepeople}
        centered
        size="lg"
        scrollable
        className="people-ratings-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>User Ratings</Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{
            maxHeight: "70vh",
            overflowY: "auto",
            backgroundColor: "#f8f9fa",
          }}
        >
          {ratingsData.map((item) => (
            <Card
              key={item.id}
              className="mb-3 shadow-sm"
              style={{
                borderRadius: "10px",
                border: "1px solid #e0e0e0",
              }}
            >
              <Card.Body>
                <Row>
                  <Col md={2} className="pe-0">
                  <img src={images.MainAvatar} height="70px" width="70px" />
                    <h6 className="mb-1 ms-3">{item.username}</h6>
                    <div>
                      {[...Array(5)].map((_, index) => (
                        <FaStar
                          key={index}
                          color={index < item.rating ? "#ffc107" : "#e4e5e9"}
                        />
                      ))}
                    </div>
                  </Col>
                  <Col md={10} className="ps-0 mt-2">
                    <p
                      className="mb-0"
                      style={{
                        fontSize: "0.95rem",
                        color: "#555",
                      }}
                    >
                      {item.description}
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          ))}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" className="pt-1 pb-1 ps-3 pe-3" onClick={handleClosepeople}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PeopleRatingsModal;
